import styled from 'styled-components'
import {
  Box,
  Tab,
  Tabs,
  RadioGroup,
  Radio,
  FormControlLabel,
  Select,
  MenuItem,
  Typography,
  Skeleton,
} from '@mui/material'
import { FilterOption } from '../../../components'
import { useUserListActionsModal } from '../../../contexts/UserListActionsModalContext'
import AutoCompleteSearch from '../AutoCompleteSearch'

const TabContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`
const WhoActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  gap: 8px;
`

const FilterOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 150px;
  overflow: auto;
`

const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

function TabContent({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <TabContentContainer>{children}</TabContentContainer>}
    </div>
  )
}

const AdministrativeTabs = () => {
  const {
    selectedTab,
    setSelectedTab,
    status,
    setStatus,
    shift,
    setShift,
    supervisionMode,
    setSupervisionMode,
    users,
    userList,
    loading,
    removeUserFromList,
    selectUser,
    shiftOptions = [],
    userOptions = [],
    supervisor,
    setSupervisor,
  } = useUserListActionsModal()

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={selectedTab} onChange={handleTabChange}>
        <Tab label="Status" />
        <Tab label="Turno" />
        <Tab label="Supervisão" />
      </Tabs>

      <WhoActionContainer>
        <span>Para quem você quer fazer essa ação?</span>
        <AutoCompleteSearch
          options={userList}
          onSelect={selectUser}
        />
        <FilterOptionsContainer>
          {loading ? (
            <>
              <Skeleton>
                <FilterOption
                  isSelected
                  dismissable
                  name='Jakob Carder'
                />
              </Skeleton>
              <Skeleton>
                <FilterOption
                  isSelected
                  dismissable
                  name='Jakob Carder'
                />
              </Skeleton>
            </>
          ) : (
            users?.map(({ id, name }) => (
              <FilterOption
                key={id}
                isSelected
                dismissable
                name={name}
                onClick={() => removeUserFromList({ id })}
              />
            ))
          )}
        </FilterOptionsContainer>
      </WhoActionContainer>

      {/* Tab 1: Status */}
      <TabContent value={selectedTab} index={0}>
        <Row>
          <Typography>Status do usuário</Typography>
          <RadioGroup
            row
            value={status}
            onChange={e => setStatus(e.target.value)}
          >
            <FormControlLabel value="Ativo" control={<Radio />} label="Ativo" />
            <FormControlLabel value="Inativo" control={<Radio />} label="Inativo" />
          </RadioGroup>
        </Row>
      </TabContent>

      {/* Tab 2: Turno */}
      <TabContent value={selectedTab} index={1}>
        <Row>
          <Typography>Seleciona para qual turno deseja mudar os usuários</Typography>
          <Select
            value={shift}
            onChange={e => setShift(e.target.value)}
            displayEmpty
          >
            <MenuItem disabled value="">
              Selecione um turno
            </MenuItem>
            {shiftOptions.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </Row>
      </TabContent>

      {/* Tab 3: Supervisão */}
      <TabContent value={selectedTab} index={2}>
        <Row>
          <Typography>Adicionar ou Remover Supervisor</Typography>
          <RadioGroup
            row
            value={supervisionMode}
            onChange={e => setSupervisionMode(e.target.value)}
          >
            <FormControlLabel value="Remover" control={<Radio />} label="Remover" />
            <FormControlLabel value="Adicionar" control={<Radio />} label="Adicionar" />
          </RadioGroup>
        </Row>
        <Row>
          <Typography>Supervisor</Typography>
          <Select
            fullWidth
            multiple
            value={supervisor}
            onChange={(e) => setSupervisor(e.target.value)}
            renderValue={(selected) =>
              selected
                .map(id => {
                  const match = userOptions.find(user => user.id === id)
                  return match?.name || id
                })
                .join(', ')
            }
          >
            <MenuItem disabled value="">
              Selecione um ou mais supervisores
            </MenuItem>
            {userOptions.map(user => (
              <MenuItem key={user.id} value={user.id}>
                {user.name}
              </MenuItem>
            ))}
          </Select>
        </Row>
      </TabContent>
    </Box>
  )
}

export default AdministrativeTabs
